(function(){
  // ---- FAQ accordion ----
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=q.closest('.faq-item');
      var was=item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function(el){el.classList.remove('open')});
      if(!was)item.classList.add('open');
    });
  });

  // ---- Floating mini promo card (appears after 5s, dismissible, persisted) ----
  var floater=document.getElementById('promoFloater');
  if(floater){
    var dismissed=false;
    try{dismissed=sessionStorage.getItem('ng5_floater_dismissed')==='1'}catch(e){}
    if(!dismissed){
      setTimeout(function(){floater.classList.add('show')},5000);
      var fc=floater.querySelector('.floater-close');
      if(fc)fc.addEventListener('click',function(){
        floater.classList.remove('show');
        try{sessionStorage.setItem('ng5_floater_dismissed','1')}catch(e){}
      });
    }
  }

  // ---- Delayed / scroll-triggered popup (7s or 25% scroll depth, once per session) ----
  var popup=document.getElementById('bundlePopup');
  if(popup){
    var already=false;
    try{already=sessionStorage.getItem('ng5_popup_shown')==='1'}catch(e){}
    if(!already){
      var shown=false;
      function show(){
        if(shown)return;shown=true;
        popup.classList.add('show');
        try{sessionStorage.setItem('ng5_popup_shown','1')}catch(e){}
      }
      var t=setTimeout(show,7000);
      window.addEventListener('scroll',function(){
        if(window.scrollY>document.body.scrollHeight*0.25){show()}
      },{passive:true});
      document.querySelectorAll('.popup-close,.popup-dismiss').forEach(function(b){
        b.addEventListener('click',function(){popup.classList.remove('show');clearTimeout(t)});
      });
      popup.addEventListener('click',function(ev){if(ev.target===popup){popup.classList.remove('show')}});
    }
  }

  // ---- Animated stat counters ----
  var counters=document.querySelectorAll('[data-count-to]');
  function animateCount(el){
    var to=parseFloat(el.getAttribute('data-count-to'));
    var suffix=el.getAttribute('data-count-suffix')||'';
    var dur=900,start=null;
    function step(ts){
      if(!start)start=ts;
      var p=Math.min(1,(ts-start)/dur);
      var val=Math.floor(p*to);
      el.textContent=val+suffix;
      if(p<1)requestAnimationFrame(step);else el.textContent=to+suffix;
    }
    requestAnimationFrame(step);
  }

  // ---- Scroll reveal for .anim elements + counters ----
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          if(entry.target.hasAttribute('data-count-to'))animateCount(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },{threshold:.2});
    document.querySelectorAll('.anim,[data-count-to]').forEach(function(el){obs.observe(el)});
  }else{
    document.querySelectorAll('.anim').forEach(function(el){el.classList.add('in')});
    counters.forEach(animateCount);
  }
})();
